import React, { useState, useEffect } from 'react';

const DemographicInfo = ({ user, onSave }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    gender: '',
    age: '',
    location: '',
    handicap: '',
    yearsPlaying: '',
    playFrequency: '',
    primaryCourse: ''
  });

  useEffect(() => {
    // In a real app, you would fetch the user's demographic data from your backend
    // For now, we'll just use placeholder data
    setFormData({
      firstName: user?.attributes?.given_name || '',
      lastName: user?.attributes?.family_name || '',
      gender: '',
      age: '',
      location: '',
      handicap: '',
      yearsPlaying: '',
      playFrequency: '',
      primaryCourse: ''
    });
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // In a real app, you would send this data to your backend
      console.log('Saving demographic data:', formData);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      onSave(true, 'Personal information updated successfully!');
    } catch (error) {
      console.error('Error saving demographic data:', error);
      onSave(false, 'Failed to update personal information. Please try again.');
    }
  };

  return (
    <div className="profile-section">
      <h2>Personal Information</h2>
      <p className="section-description">
        Tell us about yourself so we can personalize your experience and provide more relevant insights.
      </p>
      
      <form onSubmit={handleSubmit} className="profile-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="Enter your first name"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Enter your last name"
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="gender">Gender</label>
            <select
              id="gender"
              name="gender"
              value={formData.gender}
              onChange={handleChange}
            >
              <option value="">Select gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
              <option value="prefer-not-to-say">Prefer not to say</option>
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="age">Age</label>
            <select
              id="age"
              name="age"
              value={formData.age}
              onChange={handleChange}
            >
              <option value="">Select age range</option>
              <option value="under-18">Under 18</option>
              <option value="18-24">18-24</option>
              <option value="25-34">25-34</option>
              <option value="35-44">35-44</option>
              <option value="45-54">45-54</option>
              <option value="55-64">55-64</option>
              <option value="65+">65+</option>
            </select>
          </div>
        </div>
        
        <div className="form-group">
          <label htmlFor="location">Location</label>
          <input
            type="text"
            id="location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            placeholder="City, State/Province, Country"
          />
        </div>
        
        <h3>Golf Information</h3>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="handicap">Handicap</label>
            <input
              type="text"
              id="handicap"
              name="handicap"
              value={formData.handicap}
              onChange={handleChange}
              placeholder="Enter your handicap"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="yearsPlaying">Years Playing Golf</label>
            <select
              id="yearsPlaying"
              name="yearsPlaying"
              value={formData.yearsPlaying}
              onChange={handleChange}
            >
              <option value="">Select years</option>
              <option value="less-than-1">Less than 1 year</option>
              <option value="1-3">1-3 years</option>
              <option value="4-10">4-10 years</option>
              <option value="11-20">11-20 years</option>
              <option value="20+">20+ years</option>
            </select>
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="playFrequency">How often do you play?</label>
            <select
              id="playFrequency"
              name="playFrequency"
              value={formData.playFrequency}
              onChange={handleChange}
            >
              <option value="">Select frequency</option>
              <option value="daily">Daily</option>
              <option value="few-times-week">Few times a week</option>
              <option value="weekly">Weekly</option>
              <option value="few-times-month">Few times a month</option>
              <option value="monthly">Monthly</option>
              <option value="few-times-year">Few times a year</option>
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="primaryCourse">Primary Golf Course</label>
            <input
              type="text"
              id="primaryCourse"
              name="primaryCourse"
              value={formData.primaryCourse}
              onChange={handleChange}
              placeholder="Where do you play most often?"
            />
          </div>
        </div>
        
        <div className="form-actions">
          <button type="submit" className="btn-primary">Save Changes</button>
        </div>
      </form>
    </div>
  );
};

export default DemographicInfo;
